<template lang="pug">
  v-text-field(
    v-if="reactNative"
    ref="root"
    @focus="onClick"
    v-bind="$attrs"
    :value="$get(model, `fileName`)"
    :rules="rules"
    :disabled="duration === null"
    :loading="duration === null"
    readonly)
  v-file-input(
    v-else
    v-bind="$attrs"
    v-model="_model"
    :rules="rules")
</template>

<script>
import { page } from '@iez/core'
import { computed, ref, onMounted, onBeforeUnmount, watch } from '@vue/composition-api'
import initNativeCallback from '@iez/lib/init-native-callback/'

export default {
  props: {
    value: Object,
    maxDuration: Number,
    minDuration: Number
  },

  setup (props, context) {
    const duration = ref(undefined)
    const root = ref(null)

    const rules = computed(
      () => [
        ...(context.attrs.rules ?? []),
        props.maxDuration
          ? duration.value <= props.maxDuration || `La durée de la vidéo (${duration.value}s) ne doit pas dépasser ${props.maxDuration}s.`
          : null,
        props.minDuration
          ? duration.value >= props.minDuration || `La durée de la vidéo (${duration.value}s) doit être au moins ${props.minDuration}s.`
          : null
      ].filter(Boolean)
    )

    const _model = ref(null)
    watch(
      () => _model.value,
      async value => {
        if (!value) {
          context.emit(
            `input`,
            null
          )
          return
        }
        const payload = value
          ? await (async () => new Promise(resolve => {
          const video = document.createElement(`video`)
          duration.value = null
          video.preload = `metadata`
          const src = URL.createObjectURL(value)
          video.onloadedmetadata = () => {
            resolve({
              duration: video.duration,
              src
            })
          }
          video.src = src
        }))() : {}
        duration.value = payload.duration
        context.emit(
          `input`, {
            fileName: value.name,
            path: payload.src,
            duration: duration.value
          }
        )
      }
    )

    const model = computed({
      get: () => props.value,
      set: async value => {
        if (window.ReactNativeWebView) {
          context.emit(`input`, value)
        }
      }
    })
    const blockingProgressionIsActive = ref(false)
    page.blockingProgression.set(
      () => blockingProgressionIsActive.value
        ? {}
        : null
    )

    const { callback: nativeSelectVideo } = initNativeCallback({
      name: `selectVideo`,
      onResult: result => {
        if (result.noResult) {
          root.value.blur()
        } else {
          model.value = {
            fileName: result.fileName,
            path: result.path,
            width: result.width,
            height: result.height,
            duration: result.duration
          }
          duration.value = result.duration
        }
        blockingProgressionIsActive.value = false
      }
    })

    const onClick = () => {
      blockingProgressionIsActive.value = true
      nativeSelectVideo()
    }

    return {
      model,
      duration,
      rules,
      onClick,
      root,
      reactNative: !!window.ReactNativeWebView,
      _model
    }
  }
}
</script>
